<template>
  <select :name="type" @change="emitFacet">
    <template v-for="option in selectItems">
      <option
        :key="option.label"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </template>
  </select>
</template>

<script>
export default {
  name: 'FacetsTypeSelect',

  props: {
    type: {
      type: Array,
      required: true,
    },

    name: {
      type: Array,
      required: false,
      default: () => [],
    },

    options: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      selectedItems: [],
    };
  },

  computed: {
    selectItems() {
      const array = [
        {
          label: this.name[0] || this.type[0],
          value: '',
        },
      ];

      return array.concat(this.options[this.type[0]]);
    },
  },

  methods: {
    emitFacet() {
      if (this.$el.value) {
        this.selectedItems = [this.$el.value];
      } else {
        this.selectedItems = [];
      }

      this.$emit('selected', {
        value: this.selectedItems,
        key: this.type[0],
      });
    },
  },
};
</script>
